import { createFileRoute, redirect } from "@tanstack/react-router";
import { fallback, zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

import { DocumentTitle } from "@/components";
import { OtpVerifyPage } from "@/modules/auth";

const registerVerifySearchSchema = z.object({
  page: fallback(z.enum(["register", "login"]), "login").default("login")
});

export const Route = createFileRoute("/auth/verify")({
  validateSearch: zodValidator(registerVerifySearchSchema),
  component: () => (
    <>
      <DocumentTitle
        title="Verify"
        description="Verify your account with a one-time password."
      />
      <OtpVerifyPage />
    </>
  ),
  beforeLoad: ({ context }) => {
    if (context.auth.isAuthenticated) {
      throw redirect({
        to: "/"
      });
    }
  }
});
